module.exports = __webpack_public_path__ + "static/media/walkers.c03905be.png";